import { useEffect, useRef } from 'react';
import * as Sentry from '@sentry/react';
import { MessageSquare } from 'lucide-react';

export function FeedbackButton() {
  const btnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const feedback = Sentry.getFeedback();
    if (!feedback || !btnRef.current) return;
    const unsubscribe = feedback.attachTo(btnRef.current);
    return () => { if (typeof unsubscribe === 'function') unsubscribe(); };
  }, []);

  return (
    <button
      ref={btnRef}
      type="button"
      aria-label="Reportar feedback"
      title="Reportar feedback"
      className="w-8 h-8 grid place-items-center rounded-md text-fg-muted hover:bg-bg-muted hover:text-fg transition-colors duration-fast"
    >
      <MessageSquare size={16} strokeWidth={2.25} />
    </button>
  );
}
